module.exports = __webpack_public_path__ + "img/costo_azi_smartform.b70885bc.png";